import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "container py-5",
  style: {"max-width":"720px"}
}
const _hoisted_2 = { class: "swap-card card p-3 p-md-4 shadow" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_4 = { class: "d-flex align-items-center gap-2" }
const _hoisted_5 = { class: "badge rounded-pill badge-tinted small" }
const _hoisted_6 = {
  key: 0,
  class: "settings-panel surface-2 rounded p-3 mb-3"
}
const _hoisted_7 = { class: "d-flex flex-wrap gap-2 align-items-center" }
const _hoisted_8 = {
  class: "input-group input-group-sm",
  style: {"width":"140px"}
}
const _hoisted_9 = { class: "token-row mb-2" }
const _hoisted_10 = { class: "d-flex justify-content-between align-items-baseline mb-1" }
const _hoisted_11 = { class: "text-muted-token" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "swap-input" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "token-row" }
const _hoisted_16 = { class: "d-flex justify-content-between align-items-baseline mb-1" }
const _hoisted_17 = { class: "text-muted-token" }
const _hoisted_18 = { class: "swap-input" }
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "d-flex justify-content-between small mt-1" }
const _hoisted_22 = {
  key: 0,
  class: "text-muted-token d-inline-flex align-items-center gap-2"
}
const _hoisted_23 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_24 = {
  key: 2,
  class: "text-muted-token"
}
const _hoisted_25 = { class: "text-muted-token" }
const _hoisted_26 = { class: "surface-2 rounded p-3 mt-3" }
const _hoisted_27 = { class: "d-flex justify-content-between small mb-1" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 1,
  class: "text-muted-token"
}
const _hoisted_30 = { class: "d-flex justify-content-between small mb-1" }
const _hoisted_31 = { class: "d-flex justify-content-between small" }
const _hoisted_32 = { class: "mt-3" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 1,
  class: "mt-3 p-3 rounded surface-2"
}
const _hoisted_35 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_36 = { class: "mt-3" }
const _hoisted_37 = { class: "small mt-2" }
const _hoisted_38 = { class: "d-flex justify-content-between" }
const _hoisted_39 = { class: "d-flex justify-content-between" }
const _hoisted_40 = ["href"]
const _hoisted_41 = {
  key: 1,
  class: "text-muted-token"
}
const _hoisted_42 = { class: "d-flex justify-content-between" }
const _hoisted_43 = ["href"]
const _hoisted_44 = {
  key: 1,
  class: "text-muted-token"
}
const _hoisted_45 = { class: "d-flex justify-content-between" }
const _hoisted_46 = { class: "d-flex justify-content-between" }
const _hoisted_47 = ["href"]
const _hoisted_48 = {
  key: 1,
  class: "text-muted-token"
}
const _hoisted_49 = { class: "d-flex justify-content-between" }
const _hoisted_50 = ["href"]
const _hoisted_51 = {
  key: 1,
  class: "text-muted-token"
}
const _hoisted_52 = {
  key: 2,
  class: "alert alert-success mt-3"
}
const _hoisted_53 = ["href"]
const _hoisted_54 = {
  key: 3,
  class: "alert alert-danger mt-3"
}

import { onMounted, onBeforeUnmount, computed, ref, watch } from 'vue';
import { formatUnits } from 'viem';
import { useWalletStore } from '../stores/wallet';
import { useTokens } from '../composables/tokens';
import { useQuote } from '../composables/quote';
import { useSwap } from '../composables/swap';
import { usePools } from '../composables/pools';
import { appKitReady } from '../lib/appkit';
import { useToastStore } from '../stores/toast';
import { useChainStore } from '../stores/chain';


export default /*@__PURE__*/_defineComponent({
  __name: 'Swap',
  setup(__props) {

const wallet = useWalletStore();
wallet.init();

const { tokens, selectedFrom, selectedTo, fromBalance, toBalance, load, refreshBalances } = useTokens();
const fromAddr = ref<string>('');
const toAddr = ref<string>('');
const amountIn = ref('');
const amountValid = computed(() => Number(amountIn.value) > 0);

const { loading: loadingQuote, error: quoteErrRef, amountOut, usedFee, routePath, getQuote } = useQuote();
const { loading: swapping, error: swapErrRef, txHash, approve, swapExactInputSingle } = useSwap();
const { suggestions, suggestFor } = usePools();

const chain = useChainStore();
const poolFee = computed(() => Number(chain.current.uniswap?.poolFee || 3000));
const isTestnet = computed(() => chain.current.id === 11155111);
const quoterAddr = computed(() => chain.current.uniswap?.quoter || '');
const routerAddr = computed(() => chain.current.uniswap?.router || '');

const quoteOut = computed(() => amountOut.value);
const quoteErr = computed(() => quoteErrRef.value);
const swapErr = computed(() => swapErrRef.value);

const quoteOutFormatted = computed(() => {
  if (!quoteOut.value || !selectedTo.value) return '';
  return `${formatUnits(BigInt(quoteOut.value), selectedTo.value.decimals)} ${selectedTo.value.symbol}`;
});

const quoteOutNormalized = computed(() => {
  if (!quoteOut.value || !selectedTo.value) return 0;
  try { return Number(formatUnits(BigInt(quoteOut.value), selectedTo.value.decimals)); } catch { return 0; }
});

const amountInNumber = computed(() => Number(amountIn.value || '0'));
const priceText = computed(() => {
  if (!selectedFrom.value || !selectedTo.value) return '';
  if (!amountInNumber.value || !quoteOutNormalized.value) return '';
  const p = quoteOutNormalized.value / amountInNumber.value;
  if (!isFinite(p) || p <= 0) return '';
  return `1 ${selectedFrom.value.symbol} ≈ ${p.toPrecision(6)} ${selectedTo.value.symbol}`;
});

// Slippage tolerance (%), persisted
const slippage = ref<number>(Number(localStorage.getItem('swap_slippage') || '0.5'));
function persistSlippage() {
  if (Number.isNaN(slippage.value) || slippage.value < 0) slippage.value = 0.5;
  localStorage.setItem('swap_slippage', String(slippage.value));
}
function setSlippage(pct: number) { slippage.value = pct; persistSlippage(); }
const slippageBps = computed(() => Math.round((slippage.value || 0) * 100));
const minOutStr = computed(() => {
  if (!quoteOut.value) return '0';
  const q = BigInt(quoteOut.value);
  const bps = BigInt(10000 - slippageBps.value);
  return (q * bps / 10000n).toString();
});

const quoteOutDisplay = computed(() => {
  // Only show output when current input is valid
  if (!amountInNumber.value || !quoteOut.value || !selectedTo.value) return '';
  return `${formatUnits(BigInt(quoteOut.value), selectedTo.value.decimals)}`;
});

const insufficientBalance = computed(() => {
  const bal = Number(fromBalance.value || '0');
  const needed = Number(amountIn.value || '0');
  return wallet.isConnected && needed > 0 && bal < needed;
});

const canSwapUI = computed(() => wallet.isConnected && !!quoteOut.value && !swapping.value && amountInNumber.value > 0 && !insufficientBalance.value);
const showSettings = ref(false);
function toggleSettings() { showSettings.value = !showSettings.value; }
const shortAddress = computed(() => wallet.address ? `${wallet.address.slice(0,6)}…${wallet.address.slice(-4)}` : '');
const explorerBase = computed(() => chain.current.explorerBase || 'https://sepolia.etherscan.io');
const explorerTx = computed(() => txHash.value ? `${explorerBase.value}/tx/${txHash.value}` : '#');
const toSuggestions = computed(() => suggestions.value);
const toOptions = computed(() => toSuggestions.value.length ? toSuggestions.value : tokens.value);

function shortAddr(addr?: string) {
  if (!addr) return '';
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
}
function addressLink(addr: string) {
  return `${explorerBase.value}/address/${addr}`;
}
function tokenLink(addr: string) {
  const base = explorerBase.value;
  if (/scan\.io|etherscan|arbiscan|polygonscan|basescan/.test(base)) {
    return `${base}/token/${addr}`;
  }
  return `${base}/address/${addr}`;
}

// Theme-aware route-finder Lottie source
const isDarkTheme = ref((document.documentElement.getAttribute('data-theme') || 'light') === 'dark');
const lottieRouteSrc = computed(() => isDarkTheme.value ? '/assets/Cosmos%20light.json' : '/assets/Cosmos.json');
let themeObserver: MutationObserver | null = null;
function syncTheme() {
  isDarkTheme.value = (document.documentElement.getAttribute('data-theme') || 'light') === 'dark';
}

async function connect() {
  if (appKitReady()) {
    try {
      // Safely import and open AppKit modal
      const mod = await import('@reown/appkit/vue-core');
      const { open } = mod.useAppKit();
      await open();
      return;
    } catch (e) {
      // fall through to injected
    }
  }
  await wallet.openModal();
  if (!wallet.isConnected) {
    toast.push('error', 'Unable to open wallet modal. Set VUE_APP_WALLETCONNECT_PROJECT_ID or use injected wallet (MetaMask).');
  } else {
    toast.push('info', 'Connected with injected wallet');
  }
}

async function doQuote() {
  await getQuote(amountIn.value || '0');
  if (quoteErr.value) toast.push('error', quoteErr.value);
}

const toast = useToastStore();
async function doSwap() {
  if (!amountIn.value) return;
  // Approve unlimited for demo simplicity
  await approve(amountIn.value);
  const minOut = minOutStr.value;
  await swapExactInputSingle(amountIn.value, minOut, usedFee?.value || undefined, routePath?.value || null);
  if (swapErr.value) toast.push('error', swapErr.value);
  else if (txHash.value) toast.push('success', 'Swap submitted');
}

onMounted(async () => {
  await load();
  // initialize selects
  if (selectedFrom.value) fromAddr.value = selectedFrom.value.address;
  if (selectedTo.value) toAddr.value = selectedTo.value.address;
  if (selectedFrom.value) await suggestFor(selectedFrom.value.address as any, selectedFrom.value.decimals);
  // Initial auto-quote if amount prefilled
  if (amountInNumber.value > 0) await doQuote();
  // Observe theme changes
  try {
    themeObserver = new MutationObserver(() => syncTheme());
    themeObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
  } catch (_) {}
});

watch(fromAddr, (addr) => {
  const t = tokens.value.find(t => t.address === addr);
  if (t) selectedFrom.value = t;
  // Zero out input when From token changes
  amountIn.value = '';
});
watch(toAddr, (addr) => {
  const t = tokens.value.find(t => t.address === addr);
  if (t) selectedTo.value = t;
});
watch(() => wallet.address, async () => {
  await load();
  await refreshBalances();
  if (selectedFrom.value) await suggestFor(selectedFrom.value.address as any, selectedFrom.value.decimals);
});
watch(() => chain.selectedId, async () => {
  await load();
  await refreshBalances();
  if (selectedFrom.value) fromAddr.value = selectedFrom.value.address;
  if (selectedTo.value) toAddr.value = selectedTo.value.address;
  if (selectedFrom.value) await suggestFor(selectedFrom.value.address as any, selectedFrom.value.decimals);
});
watch(selectedFrom, async (t) => {
  if (t) await suggestFor(t.address as any, t.decimals);
});
watch(toOptions, (opts) => {
  if (!opts || !opts.length) return;
  const exists = opts.some((t) => t.address === toAddr.value);
  if (!exists) toAddr.value = opts[0].address;
});

// Quick-select full balance as input
function useMax() {
  const bal = String(fromBalance.value || '').trim();
  if (!bal || bal === '0') return;
  amountIn.value = bal;
}

// Flip tokens (Uniswap-style)
function flipTokens() {
  const fa = fromAddr.value;
  fromAddr.value = toAddr.value;
  toAddr.value = fa;
}

// Auto-quote on changes with debounce
let quoteTimer: number | null = null;
watch([amountIn, fromAddr, toAddr], () => {
  if (quoteTimer) { clearTimeout(quoteTimer); quoteTimer = null; }
  if (!amountInNumber.value) return; // do not quote for empty/zero
  quoteTimer = window.setTimeout(() => { doQuote(); }, 350);
});

onBeforeUnmount(() => {
  if (themeObserver) try { themeObserver.disconnect(); } catch {}
});

return (_ctx: any,_cache: any) => {
  const _component_lottie_player = _resolveComponent("lottie-player")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "fw-semibold" }, "Swap", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(isTestnet.value ? 'Testnet' : 'Mainnet'), 1),
          _createElementVNode("button", {
            class: "icon-btn",
            onClick: toggleSettings,
            "aria-label": "Swap settings"
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "bi bi-gear" }, null, -1)
          ]))])
        ])
      ]),
      (showSettings.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "d-flex align-items-center justify-content-between mb-2" }, [
              _createElementVNode("div", { class: "fw-semibold small" }, "Slippage tolerance"),
              _createElementVNode("div", { class: "small text-muted-token" }, "Auto applies to min received")
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn btn-sm", slippage.value === 0.1 ? 'btn-primary' : 'btn-outline-secondary']),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (setSlippage(0.1)))
              }, "0.1%", 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn btn-sm", slippage.value === 0.5 ? 'btn-primary' : 'btn-outline-secondary']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (setSlippage(0.5)))
              }, "0.5%", 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn btn-sm", slippage.value === 1 ? 'btn-primary' : 'btn-outline-secondary']),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (setSlippage(1)))
              }, "1.0%", 2),
              _createElementVNode("div", _hoisted_8, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "input-group-text" }, "Custom", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((slippage).value = $event)),
                  type: "number",
                  step: "0.1",
                  min: "0",
                  class: "form-control",
                  onChange: persistSlippage
                }, null, 544), [
                  [
                    _vModelText,
                    slippage.value,
                    void 0,
                    { number: true }
                  ]
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "input-group-text" }, "%", -1))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label mb-0" }, "From", -1)),
          _createElementVNode("small", _hoisted_11, [
            _createTextVNode(" Balance: " + _toDisplayString(_unref(fromBalance)) + " ", 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-link btn-sm p-0 ms-2 align-baseline",
              onClick: useMax,
              disabled: !Number(_unref(fromBalance))
            }, "Max", 8, _hoisted_12)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((amountIn).value = $event)),
            type: "number",
            inputmode: "decimal",
            class: "amount-input form-control",
            placeholder: "0.0"
          }, null, 512), [
            [_vModelText, amountIn.value]
          ]),
          _withDirectives(_createElementVNode("select", {
            class: "token-select form-select",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((fromAddr).value = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tokens), (t) => {
              return (_openBlock(), _createElementBlock("option", {
                key: t.address,
                value: t.address
              }, _toDisplayString(t.symbol), 9, _hoisted_14))
            }), 128))
          ], 512), [
            [_vModelSelect, fromAddr.value]
          ])
        ])
      ]),
      _createElementVNode("div", { class: "d-flex justify-content-center my-2" }, [
        _createElementVNode("button", {
          class: "swap-toggle",
          onClick: flipTokens,
          "aria-label": "Switch tokens"
        }, [...(_cache[13] || (_cache[13] = [
          _createElementVNode("i", { class: "bi bi-arrow-down-up" }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label mb-0" }, "To", -1)),
          _createElementVNode("small", _hoisted_17, "Balance: " + _toDisplayString(_unref(toBalance)), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("input", {
            value: quoteOutDisplay.value,
            class: "amount-input form-control",
            placeholder: "0.0",
            disabled: ""
          }, null, 8, _hoisted_19),
          _withDirectives(_createElementVNode("select", {
            class: "token-select form-select",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((toAddr).value = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toOptions.value, (t) => {
              return (_openBlock(), _createElementBlock("option", {
                key: t.address,
                value: t.address
              }, _toDisplayString(t.symbol), 9, _hoisted_20))
            }), 128))
          ], 512), [
            [_vModelSelect, toAddr.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          (_unref(loadingQuote))
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(_component_lottie_player, {
                  class: "lottie-inline",
                  src: lottieRouteSrc.value,
                  background: "transparent",
                  speed: "1",
                  loop: "",
                  autoplay: "",
                  "aria-hidden": "true"
                }, null, 8, ["src"]),
                _cache[15] || (_cache[15] = _createElementVNode("span", null, "Finding best route…", -1))
              ]))
            : (quoteErr.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(quoteErr.value), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, "Quote updates automatically")),
          _createElementVNode("div", _hoisted_25, _toDisplayString(isTestnet.value ? 'Testnet' : 'Mainnet'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _cache[16] || (_cache[16] = _createElementVNode("span", null, "Price", -1)),
          (priceText.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(priceText.value), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_29, "—"))
        ]),
        _createElementVNode("div", _hoisted_30, [
          _cache[17] || (_cache[17] = _createElementVNode("span", null, "Slippage", -1)),
          _createElementVNode("span", null, _toDisplayString(slippage.value.toFixed(2)) + "%", 1)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _cache[18] || (_cache[18] = _createElementVNode("span", null, "Pool fee", -1)),
          _createElementVNode("span", null, _toDisplayString(((_unref(usedFee) || poolFee.value) / 10000).toFixed(2)) + "%", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        (!_unref(wallet).isConnected)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary w-100",
              onClick: connect
            }, "Connect Wallet"))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-success w-100",
              disabled: !canSwapUI.value,
              onClick: doSwap
            }, _toDisplayString(_unref(swapping) ? 'Swapping…' : (insufficientBalance.value ? 'Insufficient balance' : 'Swap')), 9, _hoisted_33))
      ]),
      (toSuggestions.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "fw-semibold mb-2" }, "Swap options (Uniswap)", -1)),
            _createElementVNode("div", _hoisted_35, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toSuggestions.value, (t) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: t.address,
                  class: "badge text-bg-secondary"
                }, _toDisplayString(t.symbol), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("details", _hoisted_36, [
        _cache[26] || (_cache[26] = _createElementVNode("summary", { class: "small fw-semibold" }, "Contract details", -1)),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _cache[20] || (_cache[20] = _createElementVNode("span", null, "Network", -1)),
            _createElementVNode("span", null, _toDisplayString(isTestnet.value ? 'Testnet' : 'Mainnet') + " — " + _toDisplayString(_unref(chain).current.label), 1)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _cache[21] || (_cache[21] = _createElementVNode("span", null, "Quoter", -1)),
            _createElementVNode("span", null, [
              (quoterAddr.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: addressLink(quoterAddr.value),
                    target: "_blank",
                    rel: "noopener"
                  }, _toDisplayString(shortAddr(quoterAddr.value)), 9, _hoisted_40))
                : (_openBlock(), _createElementBlock("span", _hoisted_41, "Not configured"))
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _cache[22] || (_cache[22] = _createElementVNode("span", null, "Router", -1)),
            _createElementVNode("span", null, [
              (routerAddr.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: addressLink(routerAddr.value),
                    target: "_blank",
                    rel: "noopener"
                  }, _toDisplayString(shortAddr(routerAddr.value)), 9, _hoisted_43))
                : (_openBlock(), _createElementBlock("span", _hoisted_44, "Not configured"))
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _cache[23] || (_cache[23] = _createElementVNode("span", null, "Pool fee", -1)),
            _createElementVNode("span", null, _toDisplayString(((_unref(usedFee) || poolFee.value) / 10000).toFixed(2)) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _cache[24] || (_cache[24] = _createElementVNode("span", null, "From token", -1)),
            _createElementVNode("span", null, [
              (_unref(selectedFrom))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(selectedFrom).symbol) + " · ", 1),
                    _createElementVNode("a", {
                      href: tokenLink(_unref(selectedFrom).address),
                      target: "_blank",
                      rel: "noopener"
                    }, _toDisplayString(shortAddr(_unref(selectedFrom).address)), 9, _hoisted_47)
                  ], 64))
                : (_openBlock(), _createElementBlock("span", _hoisted_48, "Not selected"))
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _cache[25] || (_cache[25] = _createElementVNode("span", null, "To token", -1)),
            _createElementVNode("span", null, [
              (_unref(selectedTo))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(selectedTo).symbol) + " · ", 1),
                    _createElementVNode("a", {
                      href: tokenLink(_unref(selectedTo).address),
                      target: "_blank",
                      rel: "noopener"
                    }, _toDisplayString(shortAddr(_unref(selectedTo).address)), 9, _hoisted_50)
                  ], 64))
                : (_openBlock(), _createElementBlock("span", _hoisted_51, "Not selected"))
            ])
          ])
        ])
      ]),
      _cache[28] || (_cache[28] = _createElementVNode("p", { class: "text-muted-token small mt-3" }, "Non‑custodial · Verify contract addresses", -1)),
      (_unref(txHash))
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
            _cache[27] || (_cache[27] = _createTextVNode(" Success! ", -1)),
            _createElementVNode("a", {
              href: explorerTx.value,
              target: "_blank",
              rel: "noopener"
            }, "View on explorer", 8, _hoisted_53)
          ]))
        : _createCommentVNode("", true),
      (swapErr.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(swapErr.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})